import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin: 0;
`;

export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 100px;
  height: calc(100vh - 200px);
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 250px;
  height: 200px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.text};
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-3px);
  }

  svg {
    font-size: 36px;
    margin-bottom: 16px;
  }
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.3;
  color: ${({ theme }) => theme.primaryOn};
`;

// Modais
export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${({theme}) => theme.deleteModalBackground};
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.deleteModalBorder};
  padding: 24px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  
  h3 {
    color: ${({theme}) => theme.text};
    margin-bottom: 16px;
  }
  
  p {
    margin-bottom: 24px;
    line-height: 1.5;
    color: ${({theme}) => theme.text};
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${({theme}) => theme.border};
  background-color: ${({theme}) => theme.backgroundCancelButtonDeleteModal};
  color: ${({theme}) => theme.text};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${({theme}) => theme.hoverCancelButtonDeleteModal};
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
  
  label {
    display: block;
    margin-bottom: 8px;
    color: ${({theme}) => theme.text};
  }
  
  textarea {
    width: 100%;
    height: 200px;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid ${({theme}) => theme.border};
    background-color: ${({theme}) => theme.input.background};
    color: ${({theme}) => theme.text};
    resize: vertical;
    font-family: inherit;
    
    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.primaryAccent};
    }
  }
  
  input[type="file"] {
    display: block;
    width: 100%;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid ${({theme}) => theme.border};
    background-color: ${({theme}) => theme.input.background};
    color: ${({theme}) => theme.text};
    
    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.primaryAccent};
    }
  }
`;

export const FileUploadArea = styled.div`
  width: 100%;
  height: 200px;
  border: 2px dashed ${({theme}) => theme.border};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s;
  background-color: ${({theme}) => theme.input.background};
  
  &:hover {
    border-color: ${({ theme }) => theme.primaryAccent};
  }
  
  p {
    margin: 8px 0;
    color: ${({theme}) => theme.text};
  }
  
  svg {
    font-size: 48px;
    color: ${({ theme }) => theme.primaryAccent};
  }
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid ${({theme}) => theme.border};
  background-color: ${({theme}) => theme.input.background};
  color: ${({theme}) => theme.text};
  margin-bottom: 16px;
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
  }
`; 